import Vue from 'vue';
import Router from 'vue-router';
// const Vue  = () => import('vue')
// const Router  = () => import('vue-router')
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// import MainNavbar from '../layout/MainNavbar.vue';
// import MainFooter from '../layout/MainFooter.vue';
const MainNavbar  = () => import('@/layout/MainNavbar.vue')
const MainFooter = () => import('@/layout/MainFooter.vue')
import User from '../service/user';
// const User = () => import('@/service/user.js')


Vue.use(Router);

const routes = [
  // {
  //   path: '/',redirect:{name:'index'},
  // },
  {
    path:'/',
    name:'Index',
    components:{default: resolve => require (['../module/group/pages/Index.vue'],resolve)}
  },{
    path:'*',
    name:'404',
    components:{default: resolve => require (['../module/pages/404.vue'],resolve), header: MainNavbar}
  },
  {
      path: '/privacy',
      name: 'privacy',
      components: { default: resolve => require (['../module/pages/Privacy.vue'],resolve), header: MainNavbar, footer: MainFooter },
  },
  {
      path: '/tou',
      name: 'tou',
      components: { default: resolve => require (['../module/pages/Tou.vue'],resolve), header: MainNavbar, footer: MainFooter },
  },
    {
      path: '/about',
      name: 'about',
      components: { default: resolve => require (['../module/pages/About.vue'],resolve), header: MainNavbar, footer: MainFooter },
  },
  {
    path: '/help',
    name: 'help',
    components: { default: resolve => require (['../module/pages/Help.vue'],resolve), header: MainNavbar, footer: MainFooter },
    meta:{
      title:"海外群吧 - 帮助"
    }
  },
  {
    path:'/wxcbackend',
    name:'wxcbackend',
    components:{default: resolve => require (['../module/admin/WxcAdminIndex.vue'],resolve), header: MainNavbar},
    meta:{
      title:"批准申请"
    }
  }
];
const files = require.context('../module', true, /\.router.js$/);
files.keys().forEach(key => {
  routes.push(...files(key).default);
});
let router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history' ,
  routes: routes ,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
let user = new User();
router.beforeEach((to,from,next)=>{
  let status = false;
  if(to.meta.title){
    document.title = to.meta.title;
  }
  //未登录跳转
  if(to.matched.some(record=>record.meta.requiresAuth)){
    user.getUserStatus().then(res=>{
      status=res.status;
      if(!status){
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }else {
        if(to.name=="backend" && res.data.UserLevel!=2){
          next({path:'/'})
        }
        next()
      }
    })
  }else{
    next()
  }
})
export default router;
